import { render, staticRenderFns } from "./TRList.vue?vue&type=template&id=5132e52a&"
import script from "./TRList.vue?vue&type=script&lang=js&"
export * from "./TRList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports